import configs from '@/config'

/**
 * PostMessage Events Configuration for AI Chatbot
 * Manages cross-origin messaging with AI Chatbot app
 */

// PostMessage Event Types
export const POST_MESSAGE_EVENTS = {
  AI_IMPORT_REQUEST: 'AI_IMPORT_REQUEST',
}

// AI Chatbot Origins - matches the URL construction in ai-chatbot.module.js
export const ALLOWED_ORIGINS = {
  AI_CHATBOT: {
    domain: configs.aiChatbotDomain,
    // Get target origin matching the AI Chatbot URL construction
    getTargetOrigin() {
      if (!configs.aiChatbotDomain) {
        return null
      }
      return `${window.location.protocol}//${configs.aiChatbotDomain}`
    },
    // Get AI Chatbot iframe window reference
    getTargetWindow() {
      const globalChatbotContainer = document.querySelector('.global-chatbot-container')
      if (!globalChatbotContainer) {
        return null
      }

      const iframe = globalChatbotContainer.querySelector('iframe')
      return iframe?.contentWindow || null
    },
  },
}

export default {
  POST_MESSAGE_EVENTS,
  ALLOWED_ORIGINS,
}
